import { ModelInstance, Scenario } from '../types/models';

export const WEB_ASSUMPTIONS_POST = (
  instanceId: ModelInstance['id'],
  scenarioId: Scenario['id']
) => `/instances/${instanceId}/scenarios/${scenarioId}/web_assumptions_load`;

export const WEB_ASSUMPTIONS_LOAD = (
  instanceId: ModelInstance['id'],
  scenarioId: Scenario['id'],
  refreshId: number
) =>
  `/instances/${instanceId}/scenarios/${scenarioId}/web_assumptions/${refreshId}`;

export const WEB_ASSUMPTIONS_PUBLISH = (
  instanceId: ModelInstance['id'],
  scenarioId: Scenario['id']
) => `/instances/${instanceId}/scenarios/${scenarioId}/web_assumptions_publish`;

export const WEB_ASSUMPTIONS_SANDBOX_PREVIEW = (
  instanceId: ModelInstance['id'],
  scenarioId: Scenario['id']
) =>
  `/instances/${instanceId}/scenarios/${scenarioId}/web_assumptions_sandbox_refresh`;

// CLD-2970 merge routes (POST); MERGE_SUBMIT is provisional until CLD-2971 ships it.

export const MERGE_DIFF = (
  instanceId: ModelInstance['id'],
  scenarioId: Scenario['id']
) => `/instances/${instanceId}/scenarios/${scenarioId}/merge/diff`;

export const MERGE_ROWS = (
  instanceId: ModelInstance['id'],
  scenarioId: Scenario['id']
) => `/instances/${instanceId}/scenarios/${scenarioId}/merge/rows`;

export const MERGE_COUNTS = (
  instanceId: ModelInstance['id'],
  scenarioId: Scenario['id']
) => `/instances/${instanceId}/scenarios/${scenarioId}/merge/counts`;

export const MERGE_REBASE = (
  instanceId: ModelInstance['id'],
  scenarioId: Scenario['id']
) => `/instances/${instanceId}/scenarios/${scenarioId}/merge/rebase`;

export const MERGE_SUBMIT = (
  instanceId: ModelInstance['id'],
  scenarioId: Scenario['id']
) => `/instances/${instanceId}/scenarios/${scenarioId}/merge/submit`;
